<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-4">
      <div class="primary--text mb-3" style="font-size: 22px">Add line channel</div>
      <div class="form-control" :class="{ 'has-error': errors.has('Access token') }">
        <label>Access token</label>
        <textarea
          class="form-control"
          rows="5"
          maxlength="600"
          name="Access token"
          v-validate="'required'"
          v-model="input.accessToken"
          style="resize: vertical; min-height: 90px"
          :placeholder="'Access token'"
        ></textarea>
        <p class="text-error" v-if="errors.has('Access token')">
          {{ errors.first('Access token') }}
        </p>
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('Channel Secret') }">
        <label>Channel Secret</label>
        <textarea
          class="form-control"
          rows="5"
          maxlength="600"
          name="Channel Secret"
          v-validate="'required'"
          v-model="input.channelSecret"
          style="resize: vertical; min-height: 90px"
          :placeholder="'Channel Secret'"
        ></textarea>
        <p class="text-error" v-if="errors.has('Channel Secret')">
          {{ errors.first('Channel Secret') }}
        </p>
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('Channel ID') }">
        <label>Channel ID</label>
        <textarea
          class="form-control"
          rows="5"
          maxlength="600"
          name="Channel ID"
          v-validate="'required'"
          v-model="input.channelId"
          style="resize: vertical; min-height: 90px"
          :placeholder="'Channel ID'"
        ></textarea>
        <p class="text-error" v-if="errors.has('Channel ID')">
          {{ errors.first('Channel ID') }}
        </p>
      </div>
      <div class="text-xs-center">
        <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
        <v-btn :loading="saveloading" @click="onSave" depressed color="primary">Connect</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      saveloading: false,
      input: {
        channelId: '',
        channelSecret: '',
        accessToken: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async onSave() {
      if (await this.$validator.validate()) {
        this.saveloading = true
        var data = {
          ...this.input,
          pageid: this.selectedBot.pageid
        }
        api.powerbuyAddChannelLine(data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            this.saveloading = true
            api.powerbuyImportLineFollower(
              {
                pageid: this.selectedBot.pageid,
                channelId: response.data[0].channelid
              },
              (err, res) => {
                this.saveloading = false
                this.$emit('onsave', response.data[0].channelid)
              }
            )
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Management/LineAdd.vue